"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = warn;
/**
 * Log warning message to the console if `NODE_ENV` is not production.
 * @param {string} str - The warning message string
 */
function warn(str) {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(str); //eslint-disable-line no-console
  }
}